import React, { useEffect } from 'react';
import LegalLayout from '../../layouts/LegalLayout/LegalLayout';
import TermsConditionsContent from '../TermsConditionsPage/TermsConditionsContent';
import PrivacyPolicyContent from './PrivacyPolicyContent';

const PrivacyPolicyPage: React.FC = () => {
  useEffect(() => {
    const targetId = window.location.hash ? window.location.hash.replace('#', '') : 'privacidad';
    const el = document.getElementById(targetId);
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
    }
  }, []);

  return (
    <LegalLayout>
      <TermsConditionsContent />
      <PrivacyPolicyContent />
    </LegalLayout>
  );
};

export default PrivacyPolicyPage;